import request from '@/utils/request'
const centerQrcodeApi = {
  // 扫码信息保存
  saveScanInfo: (data) => {
    return request({
      url: '/public/activity-qrCode/scan',
      method: 'post',
      data
    })
  },
  // 扫码统计
  scanInfoList: (params) => {
    return request({
      url: '/public/activity-qrCode/total',
      method: 'get',
      params
    })
  }
}
export default centerQrcodeApi
